module.exports = __webpack_public_path__ + "img/image62.e260ec69.png";